import React from "react";

class DropdownClassFiscal extends React.Component {
  render() {
    return (
      <React.Fragment>
        <option></option>
        <option value="1">Continente</option>
        <option value="2">Açores</option>
        <option value="3">Madeira</option>
        <option value="4">Intracomunitários</option>
        <option value="5">Países Terceiros</option>
        <option value="6">Intracom-Particular</option>
        <option value="7">País Terc-Particular</option>
        <option value="8">Continente Particlar</option>
        <option value="9">Açores Particular</option>
        <option value="A">Madeira Particular</option>
        <option value="B">Forças Armadas</option>
      </React.Fragment>
    );
  }
}

export default DropdownClassFiscal;
